import { ControlledSelectInput2 } from 'Components';
import { AdvancedSearchContext } from 'Context/PaymentDeductionContext/AdvancedSearchProvider';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { getPaymentDeductionStatus } from 'Utils/getPaymentStatus';
import { useContext } from 'react';

export const PaymentDeductionState = () => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.PaymentsDeductions
  ).search;
  const isDesktop = useIsDesktop();

  const { advancedSearch, dispatchAdvancedSearch } = useContext(
    AdvancedSearchContext
  );

  const { opened, review, done } = dictionary.options;

  return (
    <ControlledSelectInput2
      disablePortal={isDesktop ? false : true}
      size={'small'}
      label={dictionary.accordingToState}
      options={[opened, review, done]}
      value={
        getPaymentDeductionStatus(
          advancedSearch.requestState || 0,
          dictionary.options
        ).text
      }
      onChange={(e) =>
        dispatchAdvancedSearch({
          type: 'REQUEST_STATE',
          payload: { value: e.target.value, options: dictionary.options },
        })
      }
    />
  );
};
